//React requirements
import React from 'react';
import ReactDOM from 'react-dom';

import './assets/style/index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

//Put Application requirements below this line
ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
